module.exports = __webpack_public_path__ + "img/part5-2.0414162b.png";